module.exports = __webpack_public_path__ + "images/11.a9861b00.png";